import { EventChangeArg } from '@fullcalendar/core';

export function updateEventTimeSpan(arg: EventChangeArg, eventSourceUrl: string) {
    const formData = new FormData();
    formData.append('id', arg.event.id);
    formData.append('startTime', arg.event.start.toISOString());
    formData.append('endTime', arg.event.end.toISOString());

    fetch(`${eventSourceUrl}/time-span/${arg.event.id}`, {
        method: 'PUT',
        body: formData,
    }).catch((error) => {
        console.error('Error resizing event:', error);
    }).then((response) => {
        const eventDate = new CustomEvent('refetchEvents');
        document.dispatchEvent(eventDate);
    });
}
